import HowToPlayListItem from "app/ui/HowToPlayListItem";
import TypoWord from "app/ui/TypoWord";
import cn from "app/utils/classnames";

export default function getSpellingBeeInstructions(): React.ReactNode {
  return (
    <ul className={cn("list-disc", "pl-4", "flex flex-col gap-2")}>
      <HowToPlayListItem key={0}>
        <TypoWord word="Spell" /> each word you <TypoWord word="hear" />.
      </HowToPlayListItem>
    </ul>
  );
}
